
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
  } from "firebase/firestore";

import { getDefaultFirestore } from "../apis/auth";
import { checkUserAccess } from "../apis/auth";
const dbSettingsCollection = "db_settings";
// const dimScheduleDoc = "curr_sch";


export async function getDbSettingList(dbNames) {
    console.log(`===> ${dbSettingsCollection}-Query : getDbSettingList(${dbNames})`);
    let result = [];

    if (dbNames === null || dbNames.length <= 0 || Array.isArray(dbNames) === false) {
        Promise.reject("Invalid db list");
    }

    let db = await getDefaultFirestore().catch((error) => {
        Promise.reject(error);
    });
    const collectionRef = collection(db, dbSettingsCollection);
    
    const q = query(collectionRef, where("dbName", "in", dbNames));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(doc => {
        console.log("db setting doc : ", doc.data());
        result.push(doc.data());
    });

    if (result.length > 0) {
        return Promise.resolve(result);
    }
    return Promise.reject("Unable to get user"); 
}
export async function getAllDbSettingList() {
     let result = [];

    let db = await getDefaultFirestore().catch((error) => {
        Promise.reject(error);
    });
    const collectionRef = collection(db, dbSettingsCollection);
    
    const q = query(collectionRef,);
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(doc => {
        console.log("All db setting doc : ", doc.data());
        result.push(doc.data());
    });

    if (result.length > 0) {
        return Promise.resolve(result);
    }
    return Promise.reject("Unable to get user"); 
}

// export async function updateDimSchedule(dimScheduleData) {
//     console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule()`);
//     const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
//     await updateDoc(docRef, dimScheduleData);
//     // if (docSnap.exists()) {
//         return Promise.resolve();
//     // }
//     // return Promise.reject("Unable to update dim schedule"); 
// }